export const SET_SEARCH_TERM = 'SET_SEARCH_TERM'
export const SET_PAGE_SIZE = 'SET_PAGE_SIZE'
export const SET_SORT_DIR = 'SET_SORT_DIR'
export const SET_ORDER_BY = 'SET_ORDER_BY'
export const SET_STATUS = 'SET_STATUS'
export const SET_FILTER_BY = 'SET_FILTER_BY'
export const SET_USER = 'SET_USER'
export const SET_USERS = 'SET_USERS'
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const INIT_USER = 'INIT_USER'
export const SET_HIGHLIGHT = 'SET_HIGHLIGHT'
export const SET_HIGHLIGHT_PASSWORD = 'SET_HIGHLIGHT_PASSWORD'
export const SET_USER_ROLE = 'SET_USER_ROLE'
export const SET_SOURCE = 'SET_SOURCE'



// WEBPACK FOOTER //
// ./src/store/modules/users/types.js